import mitt from 'mitt'
import type { Emitter, EventType } from 'mitt'
import type { ROOM_PK_RESULT } from './constant'

// 事件名称
export const EmitterEventType = {
  /** 展示PK结果 */
  SHOW_PK_RESULT: 'SHOW_PK_RESULT',
  /** 打开用户资料卡片 */
  OPEN_USER_CARD_POPUP: 'OPEN_USER_CARD_POPUP',
  /** 声网调用leave离开成功 */
  RTC_LEAVE_SUCCESS: 'RTC_LEAVE_SUCCESS',
  /** 房间公屏调用at用户 */
  ROOM_CHAT_AT_USER: 'ROOM_CHAT_AT_USER'
} as const

// 定义所有事件类型
interface EmitterEvents extends Record<EventType, unknown> {
  // 键: 事件名称
  // 值: 事件参数类型(可以是void表示无参数)
  [EmitterEventType.SHOW_PK_RESULT]: ROOM_PK_RESULT
  [EmitterEventType.OPEN_USER_CARD_POPUP]: string | number
  [EmitterEventType.RTC_LEAVE_SUCCESS]: void
  [EmitterEventType.ROOM_CHAT_AT_USER]: { atUid: number; atNick: string }
}

// 创建强类型的事件总线
const emitter: Emitter<EmitterEvents> = mitt<EmitterEvents>()

// 导出
export default emitter
